import * as types from '../mutation-types'
import RegionsApi from "../../api/regions";

// state
export const state = {
    regions: []
};

// getters
export const getters = {
    regions: state => state.regions
};

// mutations
export const mutations = {
    [types.REGIONS_SET] (state, regions) {
        state.regions = regions;
    }
};

// actions
export const actions = {
    async fetch(context) {
        await RegionsApi.getAll().then(function (response) {
            context.commit(types.REGIONS_SET, response)
        })
    }
};
